import { useQuery } from '@tanstack/react-query'
import { datasetsPreloadAnalyzeCreate } from '../../../../api/generated/endpoints/databook/databook'

const usePreloadDatasetAnalyze = (dataset, action) => {
  return useQuery({
    queryKey: [
      'preloadDatasetAnalysis',
      dataset?.name,
      action,
      dataset?.records?.length,
      dataset?.id,
      dataset?._searchId,
    ],
    queryFn: async () => {
      const response = await datasetsPreloadAnalyzeCreate(dataset, { action })
      return response
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    enabled: !!dataset && !!dataset.records && !!action,
  })
}

export default usePreloadDatasetAnalyze
